import React from 'react';
import { TooltipProvider } from '@/components/ui/tooltip';
import { Sheet, SheetContent, SheetTitle } from '@/components/ui/sheet';
import { LAYOUT, Z_INDEX } from '@constants/layout';
import SidebarPanel from './SidebarPanel';

interface SidebarProps {
  collapsed: boolean;
  isMobile: boolean;
  drawerOpen: boolean;
  onCloseDrawer: () => void;
  onToggle?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  collapsed,
  isMobile,
  drawerOpen,
  onCloseDrawer,
  onToggle,
}) => {
  if (isMobile) {
    return (
      <Sheet open={drawerOpen} onOpenChange={(open) => !open && onCloseDrawer()}>
        <SheetContent
          side="left"
          className="revy-ui w-[272px] max-w-[85vw] gap-0 border-r bg-card p-0 sm:max-w-[272px]"
        >
          <SheetTitle className="sr-only">REVY</SheetTitle>
          <SidebarPanel collapsed={false} onNavigate={onCloseDrawer} />
        </SheetContent>
      </Sheet>
    );
  }

  return (
    <TooltipProvider>
      <aside
        style={{
          width: collapsed ? LAYOUT.SIDEBAR_WIDTH_MINI : LAYOUT.SIDEBAR_WIDTH_EXPANDED,
          zIndex: Z_INDEX.SIDEBAR,
        }}
        className="fixed inset-y-0 left-0 border-r transition-[width] duration-200 ease-shell motion-reduce:transition-none"
      >
        <SidebarPanel collapsed={collapsed} onToggle={onToggle} />
      </aside>
    </TooltipProvider>
  );
};

export default Sidebar;
